import React from 'react';

function AdditionalInfoStep({ formData, onChange }) {
  return (
    <div className="space-y-4 border-t border-gray-200 dark:border-gray-800 pt-6">
      <h3 className="font-bold text-gray-900 dark:text-white mb-2">부가정보</h3>
      <div className="group">
        <label className="block text-xs font-bold text-gray-500 dark:text-gray-400 mb-2">성별</label>
        <div className="flex gap-4">
          <label className="flex items-center gap-2 cursor-pointer">
            <input type="radio" name="gender" value="male" checked={formData.gender === "male"} onChange={onChange} className="accent-primary" />
            <span className="text-sm dark:text-gray-300">남성</span>
          </label>
          <label className="flex items-center gap-2 cursor-pointer">
            <input type="radio" name="gender" value="female" checked={formData.gender === "female"} onChange={onChange} className="accent-primary" />
            <span className="text-sm dark:text-gray-300">여성</span>
          </label>
          <label className="flex items-center gap-2 cursor-pointer">
            <input type="radio" name="gender" value="other" checked={formData.gender === "other"} onChange={onChange} className="accent-primary" />
            <span className="text-sm dark:text-gray-300">선택안함</span>
          </label>
        </div>
      </div>
    </div>
  );
}

export default AdditionalInfoStep;
